import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["action", "presentationWidgetIdentifierWrapper", "secondsWrapper", "presentationWidgetIdentifierInput", "secondsInput"]

  connect() {
    this.toggleFields()

    // we don't get the jquery event select2 triggers in Stimulus
    $(this.actionTarget).on('change', () => {
      this.toggleFields()
    })
  }

  toggleFields() {
    const value = this.actionTarget.value

    if (["sleep"].includes(value)) {
      this.show(this.secondsWrapperTarget)
      this.hide(this.presentationWidgetIdentifierWrapperTarget)
      this.presentationWidgetIdentifierInputTarget.value = ""
    } else if (["scroll_to_widget", "play_video", "wait_for_video_to_finish"].includes(value)) {
      this.show(this.presentationWidgetIdentifierWrapperTarget)
      this.hide(this.secondsWrapperTarget)
      this.secondsInputTarget.value = ""
    } else {
      this.hide(this.presentationWidgetIdentifierWrapperTarget)
      this.hide(this.secondsWrapperTarget)
      this.presentationWidgetIdentifierInputTarget.value = ""
      this.secondsInputTarget.value = ""
    }
  }

  changeAction() {
    this.toggleFields()
  }

  show(target) {
    target.classList.remove("d-none")
  }

  hide(target) {
    target.classList.add("d-none")
  }
}
